// extracted by mini-css-extract-plugin
export default {"wrapper":"DoubleInputField_wrapper__FDda8","btnRemove":"DoubleInputField_btnRemove__JSV8D"};